<template>
  <div class="ui-content dashboard">
    <v-card class="mx-auto normal-card subscription-details">
      <div class="subscription-padding">
        <div class="subscription-details-title">
          Subscription Details:
        </div>
        <div class="subscription-details-btm-border">
          <div class="subscription-details-row">
            <div class="subscription-details-col">
              <div class="subscription-details-label">
                Number of Student Licenses:
              </div>
              <div class="subscription-details-info">
                {{ myInstitute.student_count }}
              </div>
            </div>
            <div class="subscription-details-col">
              <div class="subscription-details-label-1">
                Licenses Valid Till:
              </div>
              <div class="subscription-details-info">
                {{ getExpiryDate() }}
              </div>
            </div>
            <div class="subscription-details-col">&nbsp;</div>
            <div class="subscription-details-col">
              <div class="subscription-details-label">
                Active Students:
              </div>
              <div class="subscription-details-info">
                {{ user.total_active_student }}
              </div>
            </div>
            <div class="subscription-details-col">
              <div class="subscription-details-label-1">
                Unused Licenses:
              </div>
              <div class="subscription-details-info">
                {{ user.student_remaining_licenses }}
              </div>
            </div>
            <div class="subscription-details-col">&nbsp;</div>
            <div class="subscription-details-col">
              <div class="subscription-details-label">
                Deactivated Students:
              </div>
              <div class="subscription-details-info">
                {{ user.total_deactive_student }}
              </div>
            </div>
            <div class="subscription-details-col">
              <div class="subscription-details-label-1">
                Monthly Licensing Fee:
              </div>
              <div class="subscription-details-info">
                ₹{{ myInstitute.monthly_license_fee }}
              </div>
            </div>
            <div class="subscription-details-col">&nbsp;</div>
          </div>
        </div>
        <div class="subscription-details-title">
          Purchase More Licenses:
        </div>
        <div class="subscription-details-btm-border">
          <div class="subscription-details-row">
            <div class="subscription-details-col-1">
              <div>
                <b>Number of Additional Student Licenses needed:</b>
              </div>
              <div>
                <v-text-field
                  hide-details
                  type="Number"
                  class="LicensesNumber"
                  :min="0"
                  v-model="additionalStudent"
                ></v-text-field>
                <InputError :data="error.additionalStudent" />
              </div>
            </div>
            <div class="subscription-details-col-1">
              <div><b>Note:</b></div>
              <div>
                The additional licenses shall also expire with the current
                licenses on
                {{ billingDetails ? billingDetails.expiry_date : "-" }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="subscription-details-title">
            Billing Details:
          </div>
          <div class="subscription-details-row">
            <div class="subscription-details-col-new-1">
              <div class="subscription-details-col-input-I">
                <div class="billing-text-field">
                  <v-text-field
                    label="Billing Name"
                    hide-details
                    v-model="name"
                    dense
                    outlined
                    class="required"
                  ></v-text-field>
                  <InputError :data="error.name" />
                </div>
                <div class="billing-text-field">
                  <v-text-field
                    label="Billing Address"
                    hide-details
                    v-model="address"
                    dense
                    outlined
                    class="required"
                  ></v-text-field>
                  <InputError :data="error.address" />
                </div>
              </div>
              <div class="subscription-details-col-input-I">
                <div class="billing-text-field ">
                  <v-text-field
                    label="City"
                    hide-details
                    v-model="city"
                    dense
                    outlined
                    class="required"
                  ></v-text-field>
                  <InputError :data="error.city" />
                </div>
                <div class="billing-text-field ">
                  <v-text-field
                    label="State"
                    hide-details
                    dense
                    v-model="state"
                    outlined
                    class=""
                  ></v-text-field>
                  <InputError :data="error.state" />
                </div>
              </div>
              <div class="subscription-details-col-input-I">
                <div class="billing-text-field">
                  <v-text-field
                    label="Pincode"
                    hide-details
                    dense
                    v-model="pincode"
                    outlined
                    class="required"
                  ></v-text-field>
                  <InputError :data="error.pincode" />
                </div>
                <div class="billing-text-field">
                  <v-text-field
                    label="GSTN (if applicable)"
                    hide-details
                    v-model="gstn"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div class="subscription-details-col-input details-after-border">
              <div class="order-details-box">
                <div class="order-details-header">
                  Your Order Details:
                </div>
                <div class="net-pay-val">
                  Net Amount -
                  {{
                    billingDetails && billingDetails.net_amount
                      ? "₹ " + billingDetails.net_amount + "/-"
                      : "-"
                  }}
                </div>
                <div class="net-pay-val">
                  GST @ 18% -
                  {{
                    billingDetails && billingDetails.gst
                      ? "₹ " + billingDetails.gst + "/-"
                      : "-"
                  }}
                </div>
                <div class="net-pay-val total-pay-val">
                  <span>Total amount payable:</span
                  ><span class="amount">{{
                    billingDetails && billingDetails.total_amount
                      ? "₹ " + billingDetails.total_amount + "/-"
                      : "-"
                  }}</span>
                </div>
              </div>
              <div class="terms">
                <v-checkbox v-model="isAgreed"></v-checkbox>
                I agree with the
                <a target="_blank" v-on:click="termandcondition">
                  Terms & Conditions
                </a>
              </div>

            <div class="subscription-details-col-2 back-border">
              <v-btn
                class="cust-btn"
                color="primary"
                @click="backPurchase()"
                >Back</v-btn
              >
              <v-btn
                class="cust-btn"
                color="primary"
                @click="buyPackages"
                :disabled="!isAgreed"
                >Pay Now</v-btn
              >
            </div>
              <div class="invoice italics-styling">
                The invoice shall be e-mailed to your registered email address
                in 2 working days.
              </div>
            </div>
          </div>
          <div class="subscriptio-contact">
            For any assistance contact us at
            <a class="italics-styling" href="mailto: hello@eduracle.com"
              >hello@eduracle.com</a
            >
          </div>
        </div>
      </div>
    </v-card>
    <PaymentHiddenInput :order="order" />
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
      :contentClass="contentClass"
      :success="success"
      :failure="failure"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import PaymentHiddenInput from "./PaymentHiddenInput.vue";

export default {
  name: "PurchaseSubcription",
  mounted() {
    this.checkForStatus();
    this.addLicensesChanges();
  },
  components:{
    PaymentHiddenInput
  },
  data() {
    return {
      subscription_data: {},
      allowed_end_date: "",
      isAgreed: false,
      name: "",
      state: "",
      pincode: null,
      address: "",
      city: "",
      gstn: "",
      additionalStudent: 1,
      billingDetails: {},
      success: false,
      failure: false,
      status: false,
      modalwidth: "1000px",
      contentClass: "",
      cComponent: "components/coordinator/subscription-details/PaymentPopUp",
      alertBoxData: {},
      timeout: 0,
      error: {
        name: {
          type: null,
          message: null
        },
        address: {
          type: null,
          message: null
        },
        pincode: {
          type: null,
          message: null
        },
        city: {
          type: null,
          message: null
        },
        state: {
          type: null,
          message: null
        },
        additionalStudent: {
          type: null,
          message: null
        }
      },
      order:null,
    };
  },

  methods: {
    ...mapActions({
      // getInstituteDetails: "userStore/getInstituteDetails",
      updateTransactionStatus: "userStore/updateTransactionStatus",
      addLicenseSubscription: "userStore/addLicenseSubscription",
      createPackageOrder: "userStore/createPackageOrder",
      me: "userStore/me"
    }),
    termandcondition() {
      let routeData = this.$router.resolve({
        name: "payment-terms-and-conditions"
      });
      window.open(routeData.href, "_blank");
    },
    backPurchase() {
      this.$router.push({ name: "subscription-details" });
    },
    buyPackages() {
      var packageIdsToBuy = [];
      // this.packages.forEach((pkg) => {
      //     if (pkg.isAdded == true) {
      //     }
      // });
      this.$root.showLoader = true;

      if (this.validate()) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData = {
          product_ids: constants.PRODUCT_IDS_FOR_PURCHASE,
          success_redirect,
          failure_redirect,
          institute_id: this.myInstitute.id,
          required_licence: parseInt(this.additionalStudent),
          licence_purchase_type: constants.LICENSE_PURCHASED_TYPE.ADD,
          total_amount: this.billingDetails.total_amount,
          billing_details: {
            name: this.name,
            address: this.address,
            city: this.city,
            pincode: this.pincode,
            gstn: this.gstn,
            state: this.state
          }
        };
        sessionStorage.setItem("purchaseDetails", JSON.stringify(reqData));

        this.createPackageOrder(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.generateDataForPayment(response.order);
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    generateDataForPayment(order) {
      this.orderId = order.tx_id;
      let phoneNumber = this.user.phone;
      //phoneNumber = phoneNumber[1];
      let pd = {
        key: order.key,
        txnid: order.tx_id + "",
        amount: order.amount,
        firstname: this.user.name,
        email: this.user.email,
        phone: phoneNumber,
        productinfo: "" + order.productsForPurchase,
        surl: order.surl,
        furl: order.furl,
        hash: order.hash,
        mode: "dropout",
        udf1: order.udf1,
        udf2: order.udf2,
        udf3: order.udf3,
        udf5: "",
        pg_url:order.pg_url
    };
    this.order = pd;
      // this.launchBOLT(pd);
    },
    launchBOLT(pd) {
      let that = this;
      let handler = {
        responseHandler: function(BOLT) {
          that.checkTransactionStatus(BOLT);
        },
        catchException: function(BOLT) {
          that.handleBoltError(BOLT);
        }
      };

      bolt.launch(pd, handler);
    },
    handleBoltError(BOLT) {
      this.$toasted.error(BOLT.message);
    },
    checkTransactionStatus(BOLT) {
      if (BOLT.response.txnStatus == "CANCEL") {
        let postData = {
          order_id: this.orderId
        };
        this.updateTransactionStatus(postData)
          .then((response) => {
            // this.getPackagesList();
            this.isAgreed = false;
            this.$toasted.success("Transaction Cancelled by User.");
          })
          .catch((err) => {
            this.$toasted.error("Error while updating transaction status.");
          });
      }
    },
    currentAmount() {
      var currentAmount = 0;
      this.packages.forEach((pkg) => {
        if (pkg.isAdded) currentAmount += parseInt(pkg.price);
      });
      return currentAmount;
    },
    checkForStatus() {
      // this.$route.query
      var status = this.$route.query.status;
      if (status && status.toUpperCase() == "SUCCESS") {
        this.onDialogSuccessOpen(true);
        // this.$toasted.success("Transaction Successful.");
      } else if (status && status.toUpperCase() == "FAILED") {
        this.onDialogFailureOpen(true);
        // this.$toasted.error("Transaction Failed.");
      }
      if (status) {
        window.history.pushState({}, document.title, this.$route.path);
      }
    },
    validate() {
      let isValid = true;
      this.error.name.type = null;
      this.error.city.type = null;
      if (!this.name || this.name.trim().length < 1) {
        this.error.name.type = "error";
        this.error.name.message = "Please enter name";
        isValid = false;
      }
      if (!this.city || this.city.length < 1) {
        this.error.city.type = "error";
        this.error.city.message = "Please enter city.";
        isValid = false;
      }
      if (!this.state || this.state.length < 1) {
        this.error.state.type = "error";
        this.error.state.message = "Please enter state.";
        isValid = false;
      }
      if (!this.address || this.address.length < 1) {
        this.error.address.type = "error";
        this.error.address.message = "Please enter address.";
        isValid = false;
      }
      if (!this.pincode || this.pincode.length < 1) {
        this.error.pincode.type = "error";
        this.error.pincode.message = "Please enter pincode.";
        isValid = false;
      } else {
        if (!/^[0-9]+$/.test(this.pincode)) {
          this.error.pincode.type = "error";
          this.error.pincode.message = "Please enter valid pincode";
          isValid = false;
        }
      }

      if (!this.additionalStudent || this.additionalStudent <= 0) {
        this.error.additionalStudent.type = "error";
        this.error.additionalStudent.message =
          "Please enter atleast 1 student.";
        isValid = false;
      }
      return isValid;
    },
    addLicensesChanges() {
      const reqData = {
        institute_id: this.myInstitute.id,
        required_licence: parseInt(this.additionalStudent)
      };
      this.addLicenseSubscription(reqData)
        .then((response) => {
          this.billingDetails = response;
          this.billingDetails.expiry_date = moment(
            this.billingDetails.expiry_date
          ).format("DD-MMM-YYYY");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getExpiryDate() {
      return moment(this.myInstitute.expiry_date).format("DD - MMM - YYYY");
    },
    onDialogSuccessOpen(success) {
      let purchaseDetails = JSON.parse(
        sessionStorage.getItem("purchaseDetails")
      );
      this.cComponent =
        "components/coordinator/subscription-details/PaymentPopUp";
      this.modalwidth = "530px";
      this.contentClass = "modal-top-success";
      this.status = true;
      this.success = success;
      this.failure = false;
      this.alertBoxData = purchaseDetails;
    },
    onDialogFailureOpen(failure) {
      let purchaseDetails = JSON.parse(
        sessionStorage.getItem("purchaseDetails")
      );

      this.cComponent =
        "components/coordinator/subscription-details/PaymentPopUp";
      this.modalwidth = "530px";
      this.contentClass = "modal-top-failure";
      this.status = true;
      this.failure = failure;
      this.success = false;
      this.alertBoxData = purchaseDetails;
    },
    onClose(data) {
      this.status = data.status;
      if (data && data.failure && data.data && data.retry) {
        this.name = data.data.billing_details.name;
        this.address = data.data.billing_details.address;
        this.city = data.data.billing_details.city;
        this.pincode = data.data.billing_details.pincode;
        this.gstn = data.data.billing_details.gstn;
        this.state = data.data.billing_details.state;
        this.additionalStudent = data.data.required_licence;
        this.buyPackages();
      }
    }
  },
  computed: {
    ...mapState("userStore", ["user", "myInstitute"])
  },
  watch: {
    name() {
      this.error.name.type = null;
    },
    city() {
      this.error.city.type = null;
    },
    pincode() {
      this.error.pincode.type = null;
    },
    address() {
      this.error.address.type = null;
    },
    state() {
      this.error.state.type = null;
    },
    additionalStudent(val) {
      this.error.additionalStudent.type = null;
      if (val != 0 || val.length > 0) {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.addLicensesChanges(val);
        }, 1500);
      } else {
        this.billingDetails = {};
      }
    }
  }
};
</script>
